/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { styled, Theme } from "@mui/material/styles";

export default styled("div")(({ theme, ownerState }: { theme?: Theme | any; ownerState: any }) => {
  const { palette, borders, typography } = theme;
  const { darkMode } = ownerState;

  const { borderRadius } = borders;
  const { size } = typography;
  const { text, white, dark } = palette;

  return {
    "& .ql-toolbar": {
      borderRadius: `${borderRadius.md} ${borderRadius.md} 0 0`,
      backgroundColor: darkMode ? "rgba(255, 255, 255, 0.05)" : white.main,
      borderColor: darkMode ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",

      "& .ql-picker, & .ql-stroke": {
        stroke: `${darkMode ? white.main : dark.main} !important`,
        color: `${darkMode ? white.main : dark.main} !important`,
      },

      "& .ql-picker-label": {
        color: `${darkMode ? white.main : dark.main} !important`,
      },

      "& .ql-fill": {
        fill: `${darkMode ? white.main : dark.main} !important`,
      },

      "& .ql-picker-options": {
        backgroundColor: darkMode ? "#1a2035" : white.main,
        borderColor: darkMode ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",
        padding: "4px 0",
      },

      "& .ql-picker-item": {
        color: `${darkMode ? white.main : dark.main} !important`,
      },

      "& .ql-picker-item:hover": {
        backgroundColor: darkMode ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.04)",
        color: `${darkMode ? white.main : dark.main} !important`,
      },

      "& .ql-picker.ql-expanded .ql-picker-options": {
        backgroundColor: darkMode ? "#1a2035" : white.main,
        borderColor: darkMode ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",
      },

      // Active state for toolbar buttons (bold, italic, underline, etc.)
      "& button.ql-active": {
        backgroundColor: darkMode ? "rgba(33, 150, 243, 0.3)" : "rgba(33, 150, 243, 0.15)",
        borderRadius: "3px",

        "& .ql-stroke": {
          stroke: `${darkMode ? "#2196f3" : "#1976d2"} !important`,
        },

        "& .ql-fill": {
          fill: `${darkMode ? "#2196f3" : "#1976d2"} !important`,
        },
      },

      // Hover state for toolbar buttons
      "& button:hover": {
        backgroundColor: darkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
        borderRadius: "3px",
      },
    },

    "& .ql-container": {
      borderRadius: `0 0 ${borderRadius.md} ${borderRadius.md}`,
      backgroundColor: darkMode ? "rgba(255, 255, 255, 0.05)" : white.main,
      borderColor: darkMode ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)",
    },

    "& .ql-editor": {
      color: darkMode ? white.main : text.main,
      backgroundColor: darkMode ? "rgba(255, 255, 255, 0.05)" : white.main,

      "& p": {
        fontSize: size.md,
        color: darkMode ? white.main : text.main,
      },

      "& ul li": {
        color: darkMode ? white.main : text.main,
      },

      "& h1, & h2, & h3, & h4, & h5, & h6": {
        color: darkMode ? white.main : text.main,
      },

      "& strong, & em, & u": {
        color: darkMode ? white.main : text.main,
      },
    },
  };
});
